import { ConvertPoundsToNearestFiveKilograms } from 'functions/measurementSystemUtils'

import MiniLinearDial from 'components/Dials/MiniLinearDial'

export default function WorkoutV5Set({
    exerciseHashMap = {},
    setIndex = 0,
    exerciseId,
    setsAssigned,
    workoutSet
}) {

    if (workoutSet == null) {
        return null
    }

    const exercise = exerciseHashMap[exerciseId] ?? null
    const measurementSystem = 'imperial' // TODO: Load from backend?. Not needed yet because coach accounts do not have a way to change the measurement system
    const setUnit = exercise?.setUnit ?? 'reps'
    
    const linearDialLabel = workoutSet.setUnitsCompleted +  ' / ' + workoutSet.setUnitsAssigned + ' ' + setUnit
    const linearDialFillPercentage = (workoutSet.setUnitsCompleted / workoutSet.setUnitsAssigned) * 100

    if (exercise === null) {
        return null
    }

    return (
        <div className="py-4 pl-4 pr-2 bg-gray-100">
            <p className="pb-4">{exercise.name}</p>

            <div 
                className={`
                    grid grid-cols-9
                    ${workoutSet.completed === 1 ? 'opacity-100' : 'opacity-40'}
                `}
            >
                <div className="flex items-center font-extrabold text-gray-600 gap-x-0.5">
                    <span className="text-2xl font-semibold">{setIndex + 1}</span>
                    <span className='text-sm font-semibold'>/</span>
                    <span className="text-sm font-semibold">{setsAssigned}</span>
                </div>

                <div className="px-0.5 col-span-2 flex items-center justify-center">
                    {workoutSet.skipped === 1 && (
                        <div className="flex-grow text-center py-1 text-sm">
                            Skipped
                        </div>
                    )}

                    {workoutSet.skipped === 0 && workoutSet.completed === 1 && 
                        <>
                            {exercise.exerciseType === 'recommendation' && (
                                <div className="flex-grow text-center py-1 text-sm">
                                    {measurementSystem === 'imperial' && <>{workoutSet.weightRecommendationRounded} lbs</>}
                                    {measurementSystem === 'metric' && <>{ConvertPoundsToNearestFiveKilograms(workoutSet.weightRecommendation)} kgs</>}
                                </div>
                            )}

                            {exercise.exerciseType === 'bodyweight' && 
                                <div className="flex-grow text-center py-1 text-sm">
                                    Body
                                </div>
                            }
                        </>
                    }

                    {workoutSet.skipped === 0 && workoutSet.completed === 0 && 
                        <div className="flex-grow text-center py-1 text-sm">
                            --
                        </div>
                    }
                </div>

                <div className="mr-3 col-span-6 flex items-center justify-center">
                    <MiniLinearDial 
                        label={linearDialLabel} 
                        fillPercentage={linearDialFillPercentage} 
                    />
                </div>
            </div> 
        </div>
    )
}